import React from "react";
import { Row, Col } from "antd";

const TableFilter = ({ showFilter, children }) =>
  showFilter ? (
    <Row gutter={[0, 20]}>
      <Col>{children}</Col>
    </Row>
  ) : null;

export default TableFilter;
